import React from "react";
import Footer from "../../utils/footer";
import ContactForm from "./ContactForm";
import CompanyInformation from "../common/CompanyInformation";
import ContactCTA from "../common/ContactCTA";
import ChannelPartnerDisclosure from "../common/ChannelPartnerDisclosure";
import BusinessVerification from "../common/BusinessVerification";
import PageSeo from "../common/PageSeo";
import { BUSINESS_INFO } from "../../constants/businessInfo";

const Contact = () => {
  return (
    <main className="pt-28 bg-gray-50 text-gray-800">
      <PageSeo
        title="Contact Us"
        description="Contact Thakkhar Realtors for verified property assistance, office visit scheduling, and transparent real estate guidance."
      />

      {/* Header */}
      <section className="text-center py-10 bg-white shadow-sm">
        <h1 className="text-3xl font-bold text-blue-800">📍 Contact Us</h1>
        <p className="mt-2 text-gray-600">
          Get in touch with{" "}
          <span className="font-semibold">Thakkhar Realtors</span> - your
          trusted property experts in Panvel.
        </p>
      </section>

      <section className="max-w-6xl mx-auto pt-10 px-6">
        <CompanyInformation />
      </section>

      {/* Contact Info + Form */}
      <div className="max-w-6xl mx-auto py-12 px-6 flex flex-col lg:flex-row gap-10">
        {/* Contact Info */}
        <div className="flex-1 bg-white p-8 rounded-xl shadow-md">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Our Office
          </h2>
          <p className="text-gray-600 mb-4">
            🏢 {BUSINESS_INFO.officeAddressLine1}, {BUSINESS_INFO.officeAddressLine2},
            <br />
            {BUSINESS_INFO.city}, {BUSINESS_INFO.state} {BUSINESS_INFO.pinCode}
          </p>

          <p className="text-gray-600 mb-2">
            📞 Chirag Thakkar -{" "}
            <a
              href={`tel:${BUSINESS_INFO.phone.replace(/\s+/g, "")}`}
              className="font-medium text-blue-700 hover:underline"
            >
              {BUSINESS_INFO.phone}
            </a>
          </p>
          <p className="text-gray-600 mb-2">
            ⏰ Business Hours: <span className="font-medium">{BUSINESS_INFO.officeTimings}</span>
          </p>
          <p className="text-gray-600 mb-6">
            ✉️ Email:{" "}
            <a
              href={`mailto:${BUSINESS_INFO.businessEmail}`}
              className="text-blue-600 hover:underline"
            >
              {BUSINESS_INFO.businessEmail}
            </a>
          </p>

          <h3 className="text-lg font-semibold text-gray-800 mb-3">Visit Our Office</h3>

          <iframe
            title="Thakkhar Realtors Office Location on Google Maps"
            src={BUSINESS_INFO.mapEmbedUrl}
            className="w-full h-64 rounded-xl border-0 shadow-md"
            loading="lazy"
          ></iframe>
          <a
            href={BUSINESS_INFO.mapDirectionUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-block text-blue-700 hover:underline"
          >
            Open in Google Maps
          </a>

          <div className="mt-4 rounded-lg border border-red-100 bg-red-50 p-3 text-sm text-red-700">
            Emergency Contact: 
            <a
              href={`tel:${BUSINESS_INFO.emergencyPhone.replace(/\s+/g, "")}`}
              className="ml-1 font-medium hover:underline"
            >
              {BUSINESS_INFO.emergencyPhone}
            </a>
          </div>

          <div className="mt-4 rounded-lg border border-green-100 bg-green-50 p-3 text-sm text-green-700">
            <a
              href={`https://wa.me/${BUSINESS_INFO.whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium hover:underline"
            >
              Message us on WhatsApp
            </a>
          </div>
        </div>

        {/* Contact Form */}
        <div className="flex-1 bg-white p-8 rounded-xl shadow-md">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Send Us a Message
          </h2>
          <p className="mb-4 text-sm text-gray-600">
            Quick Contact Form: share your requirement and our team will call you back.
          </p>
          <ContactForm />
        </div>
      </div>

      <section className="max-w-6xl mx-auto px-6 pb-8">
        <BusinessVerification />
      </section>

      <section className="max-w-6xl mx-auto px-6 pb-8">
        <ChannelPartnerDisclosure forceShow />
      </section>

      <section className="max-w-6xl mx-auto px-6 pb-16">
        <ContactCTA />
      </section>

      {/* Footer */}
      <Footer />
    </main>
  );
};

export default Contact;
